// @flow

/**
 * Module dependencies.
 */

import { Col, Container, Row } from 'client/components/core/grid';
import { colors, units } from 'client/styles';
import { translator } from 'core/utils';
import Information from 'client/components/about/information';
import Layout from 'client/components/core/layout';
import React from 'react';
import TeamMember from './team-member';

/**
 * `Props` type.
 */

type Props = {
  members: Array<Object>,
  translate: Function
};

/**
 * `Team` component.
 */

function Team(props: Props): React$Element<*> {
  const { members, translate } = props;

  return (
    <Container>
      <Information
        title={translate('about.shareholders.title')}
        titleColor={colors.brandPrimary}
      >
        <Layout
          paddingTop={units(2)}
          paddingTopSm={units(0)}
        >
          <Row>
            {members.map((member, index: number) => (
              <Col
                key={member.key}
                sm={5}
                smOffset={index % 2 * 2}
              >
                <Layout marginBottom={units(6)}>
                  <TeamMember
                    description={member.description}
                    imgUrl={member.image}
                    lead={member.occupation}
                    title={member.name}
                  />
                </Layout>
              </Col>
            ))}
          </Row>
        </Layout>
      </Information>
    </Container>
  );
}

/**
 * Export `Team` component.
 */

export default translator()(Team);



// WEBPACK FOOTER //
// ../src/client/components/about/team.js